import { gql } from "apollo-boost";

export const GET_VALET_ADDON_PRICE = gql`
  query consumerValetAddonPrice(
    $branchId: String
    $startLat: String
    $startLong: String
    $endLat: String
    $endLong: String
  ) {
    consumerValetAddonPrice(
      branchId: $branchId
      startLat: $startLat
      startLong: $startLong
      endLat: $endLat
      endLong: $endLong
    )
  }
`;

export const GET_AVAILABLE_DRIVER_SLOTS = gql`
  query consumerGetDriverAvailableSlots(
    $driverAvailableSlotArgs: DriverAvailableSlotInput!
    $branchId: String!
  ) {
    consumerGetDriverAvailableSlots(
      driverAvailableSlotArgs: $driverAvailableSlotArgs
      branchId: $branchId
    ) {
      driverId
      driverName
      date
      slots {
        startTime
        endTime
      }
    }
  }
`

export const GET_DRIVER_AVAILABLE_SLOTS = gql`
  query consumerGetAvailableDriverSlots(
    $driverAvailableSlotArgs: AvailableDriverSlotInput!
    $branchId: String!
  ) {
    consumerGetAvailableDriverSlots(
      driverAvailableSlotArgs: $driverAvailableSlotArgs
      branchId: $branchId
    ) {
      date
      slots {
        startTime
        endTime
        driverId
      }
    }
  }
`;
